<div class="wrapper">

  <div class="title">
    {{'playlist.addTrack.newList.title' | translate}}
  </div>

  <div  class="textInput">
    <input
      #nameInput
      type="text"
      [value]="currentName"
      (input)="onNameChange($event.target.value)"
      (keydown.enter)="onCommitIfPossible()"
    >
  </div>

  <div class="buttonsContainer">
    <button
      class="button cancel-button" (click)="onBack()"
    >
      {{'general.button.cancel' | translate}}
    </button>

    <button
      class="button create-button" [disabled]="currentName == null || currentName == ''" (click)="onCommit()"
    >
      {{'playlist.addTrack.newList.submit' | translate}}
    </button>
  </div>
</div>
